<template>
  <div v-if="hide">

    <div class="evolution">
      <div class="evolution_nav">

        <div class="editorial_txt">
          <div class="iconfont iconhomeicon evolution_tu" style="margin-right: 5px;"></div>
          <div class="editorial_txt2">
            首页 <span class="span1">></span> <span class="span2">作者中心</span>
          </div>
        </div>


        <!-- <leftbrief :list="list" :txt="txt" :title="title" :titlename="titlename" @dian="dian"></leftbrief> -->

        <div style="display: flex;" >
          <div class="evolution_middle">
            <div class="express_rtitle">
              <div class="waike">作者中心</div>
              <div class="waixian"></div>
            </div>

            <img src="../../assets/banner111.png" alt="">

            <div class="messageMain">

              <div class="messageAll" v-for="(item, index) in deeds" @click="jump(5, item.contentId)">

                <div class="showLeft" :class="item.zt ? 'add2' : ''">

                  <span class="spanIndex">{{ index >= 9 ? (index + 1) : "0" + (index + 1) }}</span>
                  <span class="dataSpan">{{ item.addDate }}</span>
                </div>
                <li :class="item.zt ? 'add1' : ''" @mouseover="addtop2(1, item.contentId)"
                  @mouseout="addtop2(2, item.contentId)">{{ item.title }} <span style="float:right"></span> <span
                    style="float:right;paddingRight:20px;text-decoration:underline;">查看详情</span> </li>


              </div>

              <!-- <li>1233</li>
              <li></li>
              <li></li>
              <li></li>
              <li></li> -->
            </div>
          </div>

          <div class="evolution_right"  >
            <advertisement :num="num" :list2="list2"></advertisement>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//配置左侧悬浮简介导航
import leftbrief from "../public/evolution/leftbrief.vue"
//配置中间内容栏
import middlenav from "../public/evolution/evolution_nav.vue"
//配置右侧广告栏
import advertisement from "../public/evolution/advertisement.vue"

export default {
  components: {
    leftbrief,
    advertisement,
    middlenav
  },
  data() {
    return {
      one: true,
      two: false,
      hide: true,
      curr: 1,
      limit: 10,
      totalcount: 0,
      small: true,
      cename: '学术会议',
      titlename: '首页',
      title: '历届会议',
      txt: '历届会议',
      num: {
        wai: false,
        zixun: true,
        xia: true,
        look: false,
        video2: true,
      },//控制广告栏的显示隐藏
      middle: {
        brief: false,//杂志简介
        inscription: false,//领导及专家题词
        Deeds: true,//发展大事记
        Awards: false,//获奖情况
        Included: false,//检索机构收录情况
        paper: false,//论文统计与分析
        blessing: false,//祝福集锦
        meeting: false,//编委会会议
      },//中间内容区域展示模块显示隐藏
      list: [
        {
          id: 8,
          txt: '学术会议'
        },
        {
          id: 9,
          txt: '编辑委员会会议'
        },
      ],//简介导航
      list2: [
        {
          id: 1,
          txt: '多西他赛对进展期胃癌术后化疗疗效影响向...'
        },
        {
          id: 2,
          txt: '中国腹腔镜减重代谢外科20年研究文献分析...'
        }
      ],//外科天地
      deeds: [],//事情title
    }
  },

  methods: {
    tiao() {
      this.$router.push({ path: '/home' });
    },
    //左侧导航栏点击切换内容事件
    name(e) {
      console.log(e, 'e!!!!!!!!!!!')
      this.cename = e;
    },


    //会议
    GetHomePageBlockInfo(ChannelId) {
      var that = this;
      that.$httphelper.GetHomePageBlockInfo({
        "journalId": 201607080003,
        "pChannelId": 0,
        "channelId": ChannelId,
        "jChannelID": 0,
        "dataSourceType": 1,
        "dataShowType": 1,
        "curr": that.curr,
        "limit": that.limit,
      }).then(res => {
        if (res.code == 200) {

          console.log(res.data, '123123')
          that.deeds = res.data || '';
          that.deeds.map((item, index) => {
            item.addDate = item.addDate.replace(/-/g, '.')
          })
          that.totalcount = res.totalcount;
          that.hide = true;
          that.$loading.hideLoading();
        } else {
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    //页面初始化
    index() {
      //学术会议
      this.GetHomePageBlockInfo(2801)

      for (var i = 0; i < this.list.length; i++) {
        if (i == 0) {
          this.list[i].zt = true;
          this.list.push('1');
          this.list.pop('1');
        } else {
          this.list[i].zt = false;
          this.list.push('1');
          this.list.pop('1');
        }
      }
    },

    jump(num, contentId) { //详情
      this.$router.push({ path: '/expert_details', query: { num: num, contentId: contentId } });
    },
    //外科天地鼠标悬停
    addtop2(num, id) {
      if (num == 1) {
        for (var i = 0; i < this.deeds.length; i++) {
          if (id == this.deeds[i].contentId) {
            this.deeds[i].zt = true;
            this.deeds.push('1');
            this.deeds.pop('1');
          }
        }
      } else {
        for (var i = 0; i < this.deeds.length; i++) {
          this.deeds[i].zt = false;
          this.deeds.push('1');
          this.deeds.pop('1');
        }
      }
    },
  },

  created() {
    this.index();
  }
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.evolution {
  width: 100%;
  min-width: 1366px;
  background-color: #FFFFFF;
  margin-bottom: 78px;

  .evolution_nav {
    width: 85%;
    margin: 0 auto;
    overflow: hidden;

    .editorial_txt {
      width: 100%;
      margin-top: 24px;
      margin-bottom: 26px;
      overflow: hidden;

      .evolution_tu {
        width: 19px;
        height: 17px;
        float: left;
      }

      .editorial_txt2 {
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #010101;

        .span1 {
          margin: 0 5px;
        }

        .span2 {
          color: var(--xt);
        }
      }
    }

    .evolution_middle {
      width: 68%;
      float: left;
      // margin-top: 45px;
      margin-right: 100px;
      // margin-left: 20px;
      // box-shadow: 1px 2px 6px 2px #ccc;

      img {
        width: 100%;
      }

      .messageMain {
        width: 100%;
        height: 500px;
        margin-top: 50px;

        .messageAll {
          cursor: pointer;

          .showLeft {
            height: 80px;
            width: 80px;
            // border: 1px solid #767676;
            text-align: center;
            line-height: 34px;
            margin-left: 30px;
            background-color: #767676;
            // margin-top: 20px;          
            font-family: PingFangSC-Regular, PingFang SC;
            color: #e9dfdf;

            .spanIndex {
              font-size: 14px;
            }
          }

          li {
            background-color: #F1F1F1;
            width: 80%;
            height: 60px;
            line-height: 60px;
            list-style-type: none;
            padding-left: 50px;
            // margin-top: -10px;
            margin-left: 100px;
            font-size: 14px;
          }

          .dataSpan {
            // display: inline-block;
            // width: 50px;
            // height: 14px;
            font-size: 14px;
            // font-family: PingFangSC-Regular, PingFang SC;
            // font-weight: 400;
            // color: #FFFFFF;
            // line-height: 14px;
          }
        }
      }
    }

    .express_rtitle {
      width: 100%;
      overflow: hidden;
      border-bottom: 3px solid #DBDBDB;
      padding-bottom: 11px;
      position: relative;
      margin-bottom: 20px;

      // margin-top: 150px;
      .waike {
        width: 50%;
        float: left;
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2A2D3E;
        line-height: 23px;
        margin-bottom: 20px;
      }

      .waixian {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100px;
        height: 3px;
        background: var(--biao);
      }
    }



    .evolution_right {
      width: 300px;
      float: left;
      // margin-top: 40px;

      .express_right {
        width: 100%;
        margin-bottom: 50px;

        .express_rtitle {
          width: 100%;
          overflow: hidden;
          border-bottom: 3px solid #DBDBDB;
          padding-bottom: 11px;
          position: relative;

          .waike {
            width: 50%;
            float: left;
            font-size: 20px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #000000;
            line-height: 23px;
          }

          .zi {
            width: 50%;
            float: right;
            text-align: right;
            font-size: 14px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #878787;
            line-height: 23px;
            cursor: pointer;
          }

          .waixian {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 81px;
            height: 3px;
            background: var(--biao);
          }
        }

        .express_rxia {
          width: 100%;

          .express_rimg {
            width: 100%;
            height: 199px;
            margin-top: 20px;
            margin-bottom: 27px;
            cursor: pointer;
          }

          .express_rimg:hover {
            transform: scale(1.05);
          }

          .express_rtxt {
            font-size: 18px;
            font-family: Adobe Heiti Std;
            font-weight: bold;
            color: #000000;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            cursor: pointer;
          }

          .express_rlist {
            width: 100%;
            overflow: hidden;
            margin-top: 30px;
            margin-bottom: 21px;
            cursor: pointer;

            .express_dian {
              width: 10px;
              height: 10px;
              background: #DBDBDB;
              border-radius: 50%;
              margin-right: 15px;
              float: left;
              margin-top: 6px;
            }

            .wenben {
              width: 85%;
              float: left;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;
            }
          }
        }
      }

      .Journalism_one {
        width: 100%;

        .Journalism_onetop {
          width: 100%;
          overflow: hidden;
          border-bottom: 2px solid #EEEEEE;

          .Journalism_xian1 {
            width: 4px;
            height: 21px;
            background: var(--xt);
            float: left;
            margin-right: 4px;
            margin-top: 7px;
          }

          .Journalism_xian2 {
            width: 2px;
            height: 21px;
            background: var(--xt);
            float: left;
            margin-right: 12px;
            margin-top: 7px;
          }

          .Journalism_txt {
            width: 24%;
            cursor: pointer;
            font-size: 18px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #000000;
            line-height: 38px;
            position: relative;
            text-align: center;
            float: left;

            .Journalism_xian3 {
              width: 2px;
              height: 16px;
              background: #EEEEEE;
              position: absolute;
              right: 0;
              top: 14px;
            }
          }

          .Journalism_right {
            float: right;
            width: 90px;
            height: 12px;
            font-size: 14px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #878787;
            line-height: 23px;
            cursor: pointer;

            .zi {
              font-size: 14px;
              font-family: Source Han Sans SC;
              font-weight: bold;
              color: #878787;
              line-height: 23px;
              margin-right: 9px;
              margin-top: 8px;
            }
          }
        }

        .Journalism_onebottom {
          width: 100%;
          overflow: hidden;
          margin-top: 19px;

          .Journalism_list {
            width: 100%;
            overflow: hidden;
            margin-bottom: 26px;

            .Journalism_listl {
              width: 40%;
              height: 119px;
              float: left;
              cursor: pointer;
            }

            .Journalism_listl:hover {
              transform: scale(1.05);
            }

            .Journalism_listr {
              width: 53%;
              float: left;
              margin-left: 2%;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;

              a {
                font-size: 18px;
                font-family: Adobe Heiti Std;
                font-weight: bold;
                text-decoration: underline;
                line-height: 28px;
              }

              a:hover {
                color: var(--xt) !important;
              }

              .listr_xia {
                margin-top: 35px;

                span {
                  font-size: 14px;
                  font-family: Adobe Heiti Std;
                  font-weight: normal;
                  color: #757575;
                  line-height: 28px;
                }
              }
            }
          }

          .Journalism_list2 {
            width: 100%;
            overflow: hidden;
            margin-bottom: 22px;

            .Journalism_list2id,
            .Journalism_list2id2 {
              width: 5%;
              max-width: 20px;
              height: 20px;
              background: #E34919;
              border-radius: 50%;
              text-align: center;
              line-height: 20px;
              float: left;
              margin-right: 15px;
              color: #FFFFFF;
              margin-left: 2%;
            }

            .Journalism_list2id2 {
              background-color: #D2D2D2;
            }

            .kandian {
              line-height: 20px;
              float: left;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: bold;
              color: #000000;
              margin-right: 10px;
            }

            .Journalism_list2txt {
              width: 80%;
              font-size: 16px;
              line-height: 20px;
              font-family: Adobe Heiti Std;
              color: #000000;
              float: left;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              cursor: pointer;
            }
          }
        }
      }

    }
  }
}

.addtxt {
  font-weight: bold !important;
  font-size: 20px !important;
}

.add2 {
  background-color: var(--xt) !important;
}

.add1 {
  color: var(--xt) !important;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/oldmeeting.vue